import React, { useState } from "react";
import { Drawer, IconButton } from "@mui/material";
import { Menu, Close } from "@mui/icons-material";
import "../styles/SidePanel.css";

// Owl icon component for sidebar
const SidebarOwl = ({ onClick, clicked = false }) => (
  <div
    className={`dashboard-icon ${clicked ? "clicked" : ""}`}
    onClick={onClick}
    title="Click me! 🦉"
  >
    🦉
  </div>
);

function SidePanel({
  activeSection,
  onSectionChange,
  onLogout,
  userData,
  isMobile,
  isOpen,
  onToggle,
}) {
  const [owlClicked, setOwlClicked] = useState(false);

  const menuItems = [
    { id: "promocodes", label: "Promo Codes", icon: "🎫" },
    { id: "companies", label: "Companies", icon: "🏢" },
    { id: "organizations", label: "Projects", icon: "🏛️" },
    { id: "users", label: "Users", icon: "👥" },
    { id: "admin", label: "Admin", icon: "🛠️" },
    { id: "models", label: "Models", icon: "🧠" },
    { id: "rules", label: "Rules", icon: "⚖️" },
    { id: "general", label: "General", icon: "📊" },
  ];

  const handleOwlClick = () => {
    setOwlClicked(true);

    // Reset the clicked state after animation
    setTimeout(() => {
      setOwlClicked(false);
    }, 500);
  };

  const handleNavItemClick = (section) => {
    onSectionChange(section);
    // Close sidebar on mobile after navigation
    if (isMobile) {
      onToggle();
    }
  };

  const sidebarContent = (
    <>
      <div className="panel-header">
        <SidebarOwl onClick={handleOwlClick} clicked={owlClicked} />
        {isMobile && (
          <IconButton
            onClick={onToggle}
            className="close-sidebar-btn"
            sx={{
              position: "absolute",
              top: "1rem",
              right: "1rem",
              color: "#495057",
            }}
          >
            <Close />
          </IconButton>
        )}
      </div>

      <nav className="panel-nav">
        <ul className="nav-list">
          {menuItems.map((item) => (
            <li key={item.id}>
              <button
                type="button"
                className={`nav-item ${
                  activeSection === item.id ? "active" : ""
                }`}
                onClick={() => handleNavItemClick(item.id)}
              >
                <span className="nav-icon">{item.icon}</span>
                <span className="nav-label">{item.label}</span>
              </button>
            </li>
          ))}
        </ul>
      </nav>

      <div className="panel-footer">
        <button className="logout-button" onClick={onLogout}>
          <span className="logout-icon">🚪</span>
          Logout
        </button>
      </div>
    </>
  );

  if (isMobile) {
    return (
      <>
        {/* Mobile hamburger button - always visible when mobile */}
        <IconButton
          onClick={onToggle}
          className="mobile-menu-btn"
          sx={{
            position: "fixed",
            top: "1rem",
            left: "1rem",
            zIndex: 9999,
            backgroundColor: "white",
            boxShadow: 2,
            display: "block",
            visibility: "visible",
            "&:hover": {
              backgroundColor: "#f8f9fa",
            },
          }}
        >
          <Menu />
        </IconButton>

        {/* Mobile drawer */}
        <Drawer
          anchor="left"
          open={isOpen}
          onClose={onToggle}
          variant="temporary"
          ModalProps={{
            keepMounted: true, // Better mobile performance
          }}
          sx={{
            "& .MuiDrawer-paper": {
              width: 280,
              backgroundColor:
                "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
              border: "none",
            },
          }}
        >
          {sidebarContent}
        </Drawer>
      </>
    );
  }

  // Desktop sidebar
  return <aside className="side-panel">{sidebarContent}</aside>;
}

export default SidePanel;
